import React from 'react';
import { Card, Col, Row, theme } from 'antd';
import { isCustom } from '@prerender/billing-shared';
import BillingRenderUsage from '../statistics/BillingRenderUsage';
import { BillingOverviewPlan } from './BillingOverviewPlan';
import { BillingOverviewCostEstimate } from './BillingOverviewCostEstimate';
import { BillingOverviewBillingActivity } from './BillingOverviewBillingActivity';
import BillingRenderExpenses from '../statistics/BillingRenderExpenses';
import PriceUpdate2026Banner from './PriceUpdate2026Banner';
import { usePrerenderUser } from '../../../hooks/usePrerenderUser';

const BillingOverview = () => {
  const user = usePrerenderUser();
  const isUserOnCustomPlan = isCustom(user.chargebeePlanId);
  const { token } = theme.useToken();
  const cardColumnStyle = { marginBottom: token.marginSM };
  const subtitleStyle = { color: token.colorTextSecondary };

  return (
    <>
      <h3>Billing Overview</h3>
      <p style={subtitleStyle}>Here you'll find information about your subscription, render usage, and costs.</p>
      <PriceUpdate2026Banner />
      {isUserOnCustomPlan ? (
        <Row gutter={token.marginLG}>
          <Col xs={24} xl={16} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingOverviewPlan user={user} isUserOnCustomPlan showAccountDetails={true} />
            </Card>
          </Col>
          <Col xs={24} xl={8} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingOverviewBillingActivity user={user} />
            </Card>
          </Col>
        </Row>
      ) : (
        <Row gutter={token.marginLG}>
          <Col xs={24} xl={8} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingOverviewPlan user={user} showAccountDetails={true} />
            </Card>
          </Col>
          <Col xs={24} lg={12} xl={8} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingOverviewCostEstimate user={user} />
            </Card>
          </Col>
          <Col xs={24} lg={12} xl={8} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingOverviewBillingActivity user={user} />
            </Card>
          </Col>
        </Row>
      )}
      <h4 style={{ marginTop: token.marginLG }} id="render-usage">
        Render Usage
      </h4>
      <p style={subtitleStyle}>Below, you'll find your render usage report for the specified time period.</p>
      <Row gutter={token.marginLG}>
        <Col xs={24} xl={12} style={cardColumnStyle}>
          <Card style={{ height: '100%' }} variant="borderless">
            <BillingRenderUsage />
          </Card>
        </Col>
        {!isUserOnCustomPlan ? (
          <Col xs={24} xl={12} style={cardColumnStyle}>
            <Card style={{ height: '100%' }} variant="borderless">
              <BillingRenderExpenses />
            </Card>
          </Col>
        ) : null}
      </Row>
    </>
  );
};

export default BillingOverview;
